import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import useApiRequest from '../../lib/hooks/useRequest';
import { Form, FormControl, FormField, FormItem, FormMessage } from '../../ui/components/ui/form';
import { Input } from '../../ui/components/ui/input';
import GradientText from '../../ui/flow-components/gradient-text';
import TextFade from '../../ui/flow-components/text-fade';
import BgStickyGradient from './checkout/components/bg-sticky-gradient';

const ResetPassword = () => {
  const { apiRequest } = useApiRequest();

  const formSchema = z.object({
    email: z.string().email({ message: 'Bitte gib eine gültige Email-Adresse ein' }).min(2, 'Füge deine Email hinzu')
  });

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: ''
    }
  });

  const onSubmit = async (data: z.infer<typeof formSchema>) => {
    const req = {
      mail: data.email
    };
    const res = await apiRequest('user-profile/reset-password-by-mail', 'POST', {
      body: req,
      toast: {
        toastText: 'Eine E-Mail zum Passwort zurücksetzen wurde soeben versendet. Prüfen Sie auch das Spam Postfach!'
      }
    });
    setTimeout(() => {
      if (res.status < 300 && res.status >= 200) {
        window.location.href = '/';
      }
    }, 2000);
  };

  return (
    <div className="min-h-screen relative w-screen bg-[#000f0f] overflow-hidden">
      <BgStickyGradient />
      <div
        aria-hidden
        className="pointer-events-none absolute left-1/2 top-1/2 z-0 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full"
        style={{ backgroundColor: 'rgba(95, 213, 222, 0.1)', filter: 'blur(120px)' }}
      />
      <div className="flex flex-col w-full min-h-screen relative z-10 justify-center items-center p-6">
        <div className="flex flex-col items-center gap-16 ">
          <div className="flex flex-col items-center gap-2">
            <p className="text-base text-center mb-2 font-['LibreCaslonText'] italic font">
              <GradientText>7i7® flow</GradientText>
            </p>
            <p className="text-white text-2xl lg:text-4xl font-medium text-center">
              <GradientText shadow="none">Passwort</GradientText> <TextFade direction="right">zurücksetzen</TextFade>
            </p>
            <p className="text-base text-[#B2B7B7] text-center">Bitte gib deine Email Adresse an.</p>
          </div>
          <Form {...form}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation();
                form.handleSubmit(onSubmit)();
              }}
              className="flex w-full max-w-[280px] flex-col gap-4">
              <FormField
                control={form.control}
                name="email"
                render={({ field }) => (
                  <FormItem className="gap-4 w-full">
                    <div className="w-full">
                      <FormControl>
                        <Input
                          type="email"
                          placeholder="Deine E-Mail..."
                          className="h-10 rounded-full border border-white/10 bg-white/5 px-6 text-sm text-white placeholder:text-[#8FA0A0] shadow-[inset_0_-16.5px_36.9px_0_rgba(255,255,255,0.12)] backdrop-blur-[20px] focus-visible:ring-white/30"
                          {...field}
                        />
                      </FormControl>
                      <FormMessage />
                    </div>
                  </FormItem>
                )}
              />
              <div
                className="w-full rounded-full p-[1px] max-w-[280px]"
                style={{
                  background: 'linear-gradient(180deg, #266D74 0%, #B2EDFF 100%)'
                }}>
                <button
                  type="submit"
                  className="group relative flex h-10 w-full items-center justify-between rounded-full pl-4 pr-1 pb-1 pt-1 text-white transition-all hover:brightness-110"
                  style={{
                    background: 'linear-gradient(90deg, #23444B 0%, #88D4A9 88%)',
                    boxShadow: '0 2.74px 6.91px 0 #78CCC0, inset 0 2.74px 4.52px 0 #172D30'
                  }}>
                  <span className="pl-2 text-sm leading-none">
                    <span className="mr-1.5 font-['LibreCaslonText'] italic font">Passwort</span>
                    <span className="">zurücksetzen</span>
                  </span>
                  <div
                    className="flex h-full aspect-square items-center justify-center rounded-full p-1.5"
                    style={{
                      background: 'linear-gradient(135deg, #4D4D4A 0%, #747473 22%, #575757 41%, #040E0F 70%, #4D4D4D 84%, #999999 100%)'
                    }}>
                    <img src="/button-pointer.svg" alt="arrow-right" className="h-full w-full" />
                  </div>
                </button>
              </div>
            </form>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
